

export const parseInteger = (year: string, label: string) => {
	const parsedYear = Number.parseInt(year);
	if (isNaN(parsedYear)) {
		throw new Error(`Invalid ${label}: ${year} is not a valid integer.`);
	} else {
		return parsedYear;
	}
}
